import api from './api';
import UserService from './user.service';
import router from '@/router/index';
import WalletService from './wallet.service';
import { vueRoutes } from "@/router/router-const";

class AuthService {
  // userId disambiguates which account to sign into when the phone number
  // has several role-accounts (individual/legal entity/notary): omit on the
  // first attempt, resubmit with the chosen id if the response lists "accounts".
  login(user, userId) {
    return api
      .post('/identity/v1/auth', {
        login: user.login,
        password: user.password,
        user_id: userId || undefined,
      })
      .then((response) => {
        if (response.data.access_token) {
          const userWithCredentials = response.data;
          userWithCredentials.login = user.login;
          UserService.setUser(userWithCredentials);
        }
        return response.data;
      });
  }
  logout = async () => {
    await UserService.removeUser().then(() => {
      WalletService.removePrivateData();
    });
    await router.push(vueRoutes.marketplace);
    location.reload();
  };

  register(user) {
    return api.post('/identity/v1/sign-up', {
      login: user.login,
      password: user.password,
    });
  }
}

export default new AuthService();
